export default "__VITE_ASSET__C28hR$VB__"